import React from "react";
import ScriptInjector from "../script-injector";

export const Custom = (props) => {

    return <ScriptInjector html={props.slice.primary.code} />
}